import * as React from 'react'

import FormDropdown, { FormStyles } from 'embed/components/FormDropdown'
import { CREDIT_SCORE_LIST, DropdownItem } from 'embed/constants'
import { CreditScoreOptions, Filter } from 'even-ts-static'

export interface Props {
  containerClass?: string
  creditRatingLabel?: string
  dropdownOptions?: DropdownItem<CreditScoreOptions>[]
  onChange?: (fieldName: string, value: string, isValid: boolean) => void
  styles: FormStyles
  startingValue?: string
}

export const CreditScoreFilter: React.SFC<Props> = ({
  containerClass,
  creditRatingLabel,
  dropdownOptions,
  onChange,
  startingValue,
  styles,
}) => (
  <FormDropdown
    containerClass={containerClass}
    fieldName={Filter.CreditScore}
    items={dropdownOptions || CREDIT_SCORE_LIST}
    label={creditRatingLabel}
    onChange={onChange}
    startingValue={startingValue}
    styles={styles}
  />
)

CreditScoreFilter.defaultProps = {
  containerClass: '',
  creditRatingLabel: 'Credit Rating',
  onChange: () => null,
  styles: {
    dropDown: '',
    dropDownLabel: '',
    fieldError: '',
  },
}
